export const CSV_DELIMITERS = [';', ',', '\t', '|'] as const;
export type CsvDelimiter = (typeof CSV_DELIMITERS)[number];
export type CsvDelimiterMode = 'auto' | CsvDelimiter;

export function parseCsvLine(line: string, delimiter: string): string[] {
  const cells: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];
    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }
    if (char === delimiter && !inQuotes) {
      cells.push(current.trim());
      current = '';
      continue;
    }
    current += char;
  }

  cells.push(current.trim());
  return cells;
}

export function detectCsvDelimiter(text: string): CsvDelimiter {
  const lines = text.split(/\r?\n/).filter((line) => line.trim() !== '').slice(0, 5);
  if (lines.length === 0) {
    return ';';
  }

  let best: CsvDelimiter = ';';
  let bestScore = -1;
  CSV_DELIMITERS.forEach((delimiter) => {
    const score = lines.reduce((sum, line) => sum + parseCsvLine(line, delimiter).length, 0);
    if (score > bestScore) {
      bestScore = score;
      best = delimiter;
    }
  });
  return best;
}

export function parseCsvContent(text: string, mode: CsvDelimiterMode = 'auto'): string[][] {
  const delimiter = mode === 'auto' ? detectCsvDelimiter(text) : mode;
  return text
    .split(/\r?\n/)
    .map((line) => parseCsvLine(line, delimiter))
    .filter((row) => row.some((cell) => cell.trim() !== ''));
}

export function getCsvColumnOptions(headers: string[]): Array<{ value: string; label: string }> {
  return [
    { value: '', label: '— not mapped —' },
    ...headers.map((header, index) => ({
      value: String(index),
      label: header.trim() || `Column ${index + 1}`,
    })),
  ];
}
